<div class="complexMessageContainer">
    <span *ngFor="let currMessagePart of messageParts">
        <span *ngIf="currMessagePart.type == partType.TEXT" class="complexMessage_Text" [ngStyle]="{'color': currMessagePart.color == undefined ? '' : currMessagePart.color}">
            {{currMessagePart.data}}
        </span>
        <span *ngIf="currMessagePart.type == partType.ICON">
            <mat-icon [ngStyle]="{'color': currMessagePart.color == undefined ? '' : currMessagePart.color}">{{currMessagePart.data}}</mat-icon>
        </span>
    </span>
</div>
